export const ALL_STATUSES = "all statuses";
export const ALL_CATEGORIES = "all categories";

export interface RoomFilterDraft {
  status: string;
  category: string;
}

interface AppliedRoomFilters {
  status?: string;
  categoryId?: string;
  category?: string;
}

export function createRoomFilterDraft(
  applied: AppliedRoomFilters,
): RoomFilterDraft {
  return {
    status: applied.status || ALL_STATUSES,
    category: applied.categoryId || applied.category || ALL_CATEGORIES,
  };
}

/** Values that differ between the draft and the applied filters. */
export function getAppliedRoomFilterChanges(
  draft: RoomFilterDraft,
  applied: RoomFilterDraft,
): Partial<RoomFilterDraft> {
  const changes: Partial<RoomFilterDraft> = {};
  if (draft.status !== applied.status) changes.status = draft.status;
  if (draft.category !== applied.category) changes.category = draft.category;
  return changes;
}

export function countActiveRoomFilters(draft: RoomFilterDraft): number {
  return (
    (draft.status !== ALL_STATUSES ? 1 : 0) +
    (draft.category !== ALL_CATEGORIES ? 1 : 0)
  );
}
